module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "index-view"
    }
  }, [_c('div', {
    attrs: {
      "id": "wideContent"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "boxContent"
  }, [_c('h1', [_vm._v("Vítejte na stránkách Salonu Jája")]), _vm._v(" "), _c('p', [_vm._v("\n            Jsme psí salon, který poskytuje vašim čtyřnohým mazlíčkům\n            tyto "), _c('router-link', {
    attrs: {
      "to": "/service"
    }
  }, [_vm._v("služby")]), _vm._v(": "), _c('b', [_vm._v("koupání")]), _vm._v("\n            a "), _c('b', [_vm._v("stříhání psů")]), _vm._v(", "), _c('b', [_vm._v("trimování")]), _vm._v(", "), _c('b', [_vm._v("psí masáže")]), _vm._v(", "), _c('b', [_vm._v("rozčesávání")]), _vm._v(",\n\t\t\t\t\t\t"), _c('b', [_vm._v("úpravu drápků")]), _vm._v(", "), _c('b', [_vm._v("ošetření uší a očí")]), _vm._v(". Dále\n\t\t\t\t\t\tnabízíme poradenství v oblasti výchovy a výcviku psů nebo po\n\t\t\t\t\t\tdohodě s námi splnění jiných nadstandardních přání.\n\t\t\t\t\t")], 1), _vm._v(" "), _c('p', [_vm._v("\n            Salon slouží zároveň jako kamenný obchod, takže si u\n            nás můžete zakoupit různé kosmetické či jiné potřeby pro\n            pejsky a kočičky.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            Naše provozovna se nachází na adrese Pražského\n            662, Praha 5 - Hlubočepy (Barrandov), kdy vchod do\n            salonu je umístěn z boku domu, více informací o tom jak se k\n            nám dostat spolu s mapkou přesného umístění naleznete v "), _c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("kontaktech")]), _vm._v(".\n\t\t\t\t\t")], 1), _vm._v(" "), _c('p', [_vm._v("\n            Pokud chcete blíže poznat prostředí salonu, před tím, než do\n            něj přivedete svého psího miláčka, "), _c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("zde")]), _vm._v(" naleznete fotografie interiéru salonu\n\t\t\t\t\t\ta i našich psích a jednoho kočíčího mazla, kteří se zdají\n\t\t\t\t\t\tbýti naším hýčkáním nadmíru spokojeni ;-)\n\t\t\t\t\t")], 1), _vm._v(" "), _c('p', [_vm._v("\n            Salon Jája zavedl prodej "), _c('b', [_vm._v("dárkových poukazů")]), _vm._v(", kterými mohou páníčkové obdarovat své psí miláčky\n\t\t\t\t\t\tnebo touto formou obdarovat majitele pejska a udělat tak radost oběma.\n\t\t\t\t\t\tDárkové poukazy zahrnují veškeré inzerované služby v uvedené ceně.\n\t\t\t\t\t\tBližší informace naleznete v sekci "), _c('router-link', {
    attrs: {
      "to": "/voucher"
    }
  }, [_vm._v("Dárkové poukazy")]), _vm._v(".\n\t\t\t\t\t")], 1), _vm._v(" "), _c('p', [_vm._v("\n            V případě jakýchkoliv dotazů či připomínek nás neváhejte\n            "), _c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("kontaktovat")]), _vm._v(".\n\t\t\t\t\t")], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "cleaner"
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "boxContent"
  }, [_c('div', {
    staticClass: "photo200"
  }, [_c('a', {
    staticClass: "photo fancybox",
    attrs: {
      "href": require('../../../static/photos/index/1_pred.jpg'),
      "rel": "group",
      "title": "Před stříháním"
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('a', {
    staticClass: "photo fancybox",
    attrs: {
      "href": require('../../../static/photos/index/1_po.jpg'),
      "rel": "group",
      "title": "Po stříhání"
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "cleaner"
  }), _vm._v(" "), _c('a', {
    staticClass: "photo fancybox",
    attrs: {
      "href": require('../../../static/photos/index/2_pred.jpg'),
      "rel": "group",
      "title": "Před stříháním"
    }
  }, [_vm._m(3)]), _vm._v(" "), _c('a', {
    staticClass: "photo fancybox",
    attrs: {
      "href": require('../../../static/photos/index/2_po.jpg'),
      "rel": "group",
      "title": "Po stříhání"
    }
  }, [_vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "cleaner"
  }), _vm._v(" "), _c('a', {
    staticClass: "photo fancybox",
    attrs: {
      "href": require('../../../static/photos/index/3_pred.jpg'),
      "rel": "group",
      "title": "Před stříháním"
    }
  }, [_vm._m(5)]), _vm._v(" "), _c('a', {
    staticClass: "photo fancybox",
    attrs: {
      "href": require('../../../static/photos/index/3_po.jpg'),
      "rel": "group",
      "title": "Po stříhání"
    }
  }, [_vm._m(6)]), _vm._v(" "), _c('div', {
    staticClass: "cleaner"
  }), _vm._v(" "), _c('a', {
    staticClass: "photo fancybox",
    attrs: {
      "href": require('../../../static/photos/index/4_pred.jpg'),
      "rel": "group",
      "title": "Před stříháním"
    }
  }, [_vm._m(7)]), _vm._v(" "), _c('a', {
    staticClass: "photo fancybox",
    attrs: {
      "href": require('../../../static/photos/index/4_po.jpg'),
      "rel": "group",
      "title": "Po stříhání"
    }
  }, [_vm._m(8)]), _vm._v(" "), _c('div', {
    staticClass: "cleaner"
  }), _vm._v(" "), _c('a', {
    staticClass: "photo fancybox",
    attrs: {
      "href": require('../../../static/photos/index/5_pred.jpg'),
      "rel": "group",
      "title": "Před stříháním"
    }
  }, [_vm._m(9)]), _vm._v(" "), _c('a', {
    staticClass: "photo fancybox",
    attrs: {
      "href": require('../../../static/photos/index/5_po.jpg'),
      "rel": "group",
      "title": "Po stříhání"
    }
  }, [_vm._m(10)])]), _vm._v(" "), _c('div', {
    staticClass: "cleaner"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cleaner"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "boxTitle"
  }, [_c('h2', [_vm._v("Před a po stříhání")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../../static/photos/index/thumb_1_pred.jpg"),
      "width": "200"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../../static/photos/index/thumb_1_po.jpg"),
      "width": "200"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../../static/photos/index/thumb_2_pred.jpg"),
      "width": "200"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../../static/photos/index/thumb_2_po.jpg"),
      "width": "200"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../../static/photos/index/thumb_3_pred.jpg"),
      "width": "200"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../../static/photos/index/thumb_3_po.jpg"),
      "width": "200"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../../static/photos/index/thumb_4_pred.jpg"),
      "width": "200"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../../static/photos/index/thumb_4_po.jpg"),
      "width": "200"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../../static/photos/index/thumb_5_pred.jpg"),
      "width": "200"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": require("../../../static/photos/index/thumb_5_po.jpg"),
      "width": "200"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bacac12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/IndexView.vue
// module id = 76
// module chunks = 0